<template>
<div>

  <ul class="pro-flex-list">
    <li
      class="pro"
      v-for="(item) in list"
      :key="item.id"
    >
      <template v-if="item.image_url">
        <router-link tag="a" target="_blank" :to="{name:'detail',params: {goodsId:item.id}}">
          <div class="pro-img">
            <img v-lazy="item.image_url" alt :key="item.image_url">
            <div class="img-no" v-if="item.stock_status && item.stock_status.status != 1">
              <img src="@/assets/images/nostock.png" />
            </div>
          </div>
          <div class="title">{{item.name}}</div>
          <div class="integral" v-if="item.usable_price && item.usable_price > 0"><span>X币可抵扣￥{{item.usable_price}}</span></div>
          <div class="price-wrap">
            <div class="price">{{$t('currencySymbol')}}{{item.price}}</div>
          </div>
        </router-link>
       <div class="add-wrap">
         <router-link  class="info-img" :to="{name:'detail',params: {goodsId:item.id}}"></router-link>
         <!-- <div class="info-img"></div> -->
        <div class="add-cart nostock" v-if="item.stock_status && item.stock_status.status != 1">商品已售罄</div>
         <!-- 加入购物车 -->
         <div v-else>
          <div class="add-cart" v-if="!($store.state.config.account_switch == 1 && item.account_id)" @click="addToCart(item, item.product.id)">{{$t('addToCart')}}</div>
          <div class="add-cart" v-else @click="buyNow(item, item.product.id)">立即购买</div>
         </div>
       </div>
      </template>
    </li>
  </ul>
  <div class="drawer-wrap" :class="{show: show}"  @click.self="show = false">
    <div class="drawer-bg" @click="show = false"></div>
    <div class="drawer-content">
      <div class="att-popup-header">
        <div class="thumb"> <img :src="product.image_path" alt="" width="100%" height="100%"> </div>
        <div class="info">
          <!-- 销售价 -->
          <div>{{$t('salePrice')}}：{{$t('currencySymbol')}} {{product.price}} </div>
          <!-- 起订量 -->
          <div>{{$t('moq')}}： 1</div>
        </div>
      </div>
      <template v-if="product && product.default_spes_desc">
        <div class="tr-group" v-for="(value,key,i) in product.default_spes_desc" :key="i">
          <div class="tr-title-left">{{key}}</div>
          <div class="tr-right">
            <div class="color" v-for="(item,index) in value" :key="index" :class="{'active':item.cla.indexOf('is-selected') > -1, 'diable': item.disable }" 
            @click="changeSpes( key, item.name, item.disable)">
              <a href="javascript:;">{{item.name}}</a>
            </div>
          </div>
        </div>
      </template>

       <div class="tr-group">
        <div class="tr-title-left">{{$t('nums')}}</div>
        <div class="tr-right">
          <el-input-number v-model="buyNum"  :min="1" :label="$t('buyNums')" size="small" :max="buyMax"></el-input-number>
          <div class="kc">{{$t('inventory')}}{{product.stock}}{{$t('piece')}}</div>
        </div>
      </div>
<!-- 确定 -->
      <div class="submit" @click="addToCartAction">{{$t('confirm')}}</div>
    </div>
  </div>
</div>
  
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "ProductRowFive",
  components: {},
  props: {
    row: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      show: false,
      product: {},
      buyNum: 1,
      specData: {},
      minBuyNum: 1,
      goodac: '', // 多规格选中商品account_id
    };
  },
  watch: {
    show(v1, v2) {
      if(!v1) {
        this.specData = {}
      }
    }
  },
  destroyed() {
    // console.log('destroyed', destroyed)
  },
  computed: {
    buyMax() {
      return this.product.stock
    },
    handleData() {
      // let data = this.list;
      // data.forEach(() => {
      //   let list = data.length;
      //   let num = list % 5;
      //   if (num !== 0) {
      //     for (let i = 0; i < 5 - num; i++) {
      //       data.push({});
      //     }
      //   }
      // });
      // return this.list;
    }
  },
  methods: {
    ...mapActions(["getCartNumsAction"]),
    //切换收藏
    changeFav(id) {
      let data = {
        goods_id: id
      };
      this.$api.goodsCollection(data).then(res => {
        if (res.status) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success"
          });
        }
      });
    },
    // 1大 2小 对象是否包含
    isInclude(array1,array2){
      let key = Object.keys(array2)[0]
      let value = array2[key]
      for(let i of array1) {
        if(Object.keys(i)[0] == key && value == i[ Object.keys(i)[0]]) {
        return true
        }
      }
      return false
    },
    //切换商品规格
    changeSpes(id, item, disable) {
      if(disable) {
        return
      }
			const _this = this
			// console.log(obj, this.product.spec_product);
			let index = id;
			let key = item;
			// 没有选中 切换为选中状态
			if(this.product.default_spes_desc[index][key].cla.indexOf('not-selected') > -1) {
				// 当前组 全部恢复默认
				for(let i in this.product.default_spes_desc[index]) {
					this.$set(this.product.default_spes_desc[index][i], 'cla', 'pop-m-item not-selected');
				}
				// 存储当前选中的规格
				this.$set(this.specData, index, key)
				// 改变当前为选中状态
				this.$set(this.product.default_spes_desc[index][key], 'cla', 'pop-m-item is-selected');
        
        // 只要点击了带有图片的规格且为选中状态，马上切换弹出层商品图
        if (this.product && this.product.default_spes_desc && this.product.default_spes_desc[index] && this.product.default_spes_desc[index][key]) {
          let specObj = this.product.default_spes_desc[index][key];
          if (specObj.cla.indexOf('is-selected') > -1 && specObj.image_id && specObj.image_id.length > 0) {
            this.$set(this.product, 'image_path', specObj.image_id[0].src);
          }
        }
			} else {
				// 如果选中了 取消
				delete this.specData[index]
				this.$set(this.product.default_spes_desc[index][key], 'cla', 'pop-m-item not-selected');
				// 一个规格取消 直接return
				if(this.product.default_spes_desc && Object.keys(this.product.default_spes_desc).length == 1 ) {
					return
				}
			}
			
			let str = ''
			for(let z in this.specData) {
				str += `${z}:${this.specData[z]},`
			}
			if(str.length) {
				str = str.substr(0, str.length - 1)
			}

			this.$api.getproductbysku({
				id: _this.product.goods_id,
				spec: str
			}).then(res => {
				if(res.status) {
          if(res.data.length > 0) {
					let prod = res.data
					for(let k in this.product.default_spes_desc) { 
						for(let spec_value of  Object.keys(this.product.default_spes_desc[k])) {
							// console.log('this.product.default_spes_desc[k][spec_value].disable', this.product.default_spes_desc[k][spec_value].disable);
							if( str.length == 0) {
								this.$set(this.product.default_spes_desc[k][spec_value], 'disable', false)
							} else {
								let arr = 0
								
								let data = []
								let concatArr = []
								let obj = {}
								obj[k] = spec_value
								
								for(let i in prod) {
									if(prod[i].spes_desc.indexOf(`${k}:${spec_value}`) < 0 || !this.isInclude(prod[i].spec, obj) ) {
										arr++
									} 
								}
								// 一个规格
								if(Object.keys(this.product.default_spes_desc).length == 1) {
									if(prod[0].spes_desc.indexOf(`${k}:${spec_value}`) > -1) {
										this.$set(this.product.default_spes_desc[k][spec_value], 'disable', false)
									} else {
										// 如果点击的当前规格组 什么也不做
										if(Object.keys(this.specData).join(',').indexOf(k) > -1 ) {
											
										} else {
											this.$set(this.product.default_spes_desc[k][spec_value], 'disable', true)
										}
									}
								} else {
									// 多规格
									if(arr == prod.length ) {
										// 如果点击的当前规格组 什么也不做
										if(Object.keys(this.specData).join(',').indexOf(k) > -1 ) {
										} else {
											this.$set(this.product.default_spes_desc[k][spec_value], 'disable', true)
										}
									} else {
										this.$set(this.product.default_spes_desc[k][spec_value], 'disable', false)
									}
								}
							}
						}
					}
					
					if(Object.keys(this.specData).length == Object.keys(this.product.default_spes_desc).length) {
						let data = {
						    id: prod[0].id
						};
						// return
            
						let userToken = this.$storage.get("userToken");
						if (userToken) {
						    data['token'] = userToken;
						}
						this.$api.getProductInfo(data).then(result => {
						    if (result.status == true) {
						        // 切换规格判断可购买数量
						        this.buyNum = result.data.stock > this.minBuyNum ? this.minBuyNum : result.data.stock;
								let copy = JSON.parse(JSON.stringify(this.product.default_spes_desc)) 
						        this.product = result.data
								this.$set(this.product, 'default_spes_desc', copy)
						    }
						});
					}
				} else {
          // this.$message({
          //   message: "暂无库存, 请重新选择",
          //   icon: 'none'
          // })

          //  // 如果选中了 取消
          // delete this.specData[id]
          // this.$set(this.product.default_spes_desc[id][item], 'cla', 'pop-m-item not-selected');
          // this.changeSpes()

          if(Object.keys(this.product.default_spes_desc).length > 0 && id) {
            let strArr = []
            for(let i in this.product.default_spes_desc) {
              strArr.push(i)
            }
              const findcurrentIndex = strArr.findIndex(item => item == id)
              strArr = strArr.splice(findcurrentIndex + 1, strArr.length - 1)
              for(let k in this.specData) {
                for(let j of strArr) {
                  if(j == k) {
                    delete this.specData[k]
                    for(let z in this.product.default_spes_desc[k]) {
                      this.$set(this.product.default_spes_desc[k][z], 'cla', 'pop-m-item not-selected');
                    }
                  }
                }
              }
              this.changeSpes()
          }
        }
        } 
			})
    },
    addToCartAction() {

      if(this.product.default_spes_desc && (Object.keys(this.specData).length != Object.keys(this.product.default_spes_desc).length)) {
			  this.$message({
          message: this.$t('pleaseSelectSpecification'), // "请选择规格",
          type: 'error'
        })
				return
			}


      let data = {
        product_id: this.product.id,
        nums: this.buyNum,
      }
      if(this.goodac) {
        data['type'] = 2
      }
      const _this = this
      this.$api.addCart(data).then(res => {
        if (res.status) {
          if(!_this.goodac) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
            _this.show = false
            this.specData = {}
            this.getCartNums();
          }else{
            let cartIds = res.data;
            _this.$router.push({
              name: "order",
              query: { cart_ids: JSON.stringify(cartIds) }
            });
          }
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    spesClassHandle(products, flag) {
      // 判断是否是多规格 (是否有默认规格)
      if (products.hasOwnProperty('default_spes_desc')) {
          let spes = products.default_spes_desc;
          for (let key in spes) {
              for (let i in spes[key]) {
                if(flag) {
                  this.$set(spes[key][i], 'cla', 'pop-m-item' );
                } else {
                  this.$set(spes[key][i], 'cla', 'pop-m-item not-selected' );
                }
              }
          }
          products.default_spes_desc = spes;
      }
      return products;
    },
    addToCart(val, id) {
      const _this = this
      // 多规格
      if(val.product.default_spes_desc) {
        this.$api.goodsDetail({ id: val.id }).then(res => {
          if (res.status) {
            if (res.data.product && res.data.product.default_spes_desc) {
              res.data.product.default_spes_desc = this.sortSpecs(res.data.product.default_spes_desc, res.data.new_spec);
            }
            this.product = this.spesClassHandle(res.data.product);
            this.show = true
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        });
      } else {
        this.product = this.spesClassHandle(val.product);
        let data = {
          product_id: id,
          nums: 1
        };
        this.$api.addCart(data).then(res => {
        if (res.status) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
            _this.show = false
            this.getCartNums();
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      });
      }

      
      // if(val.product.default_spes_desc) {
      //   this.show = true
      // } else {
      //   let data = {
      //     product_id: id,
      //     nums: 1
      //   };
        
      // }
    },
    buyNow(val, id) {
      const _this = this
      // 多规格
      if(val.product.default_spes_desc) {
        if(this.$store.state.config.account_switch == 1) {
          this.goodac = val.account_id
        }
        this.$api.goodsDetail({ id: val.id }).then(res => {
          if (res.status) {
            if (res.data.product && res.data.product.default_spes_desc) {
              res.data.product.default_spes_desc = this.sortSpecs(res.data.product.default_spes_desc, res.data.new_spec);
            }
            this.product = this.spesClassHandle(res.data.product);
            this.show = true
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        });
      } else {
        this.product = this.spesClassHandle(val.product);
        let data = {
          product_id: id,
          nums: 1,
          type: 2 // 区分加入购物车和购买
        };
        this.$api.addCart(data).then(res => {
        if (res.status) {
            let cartIds = res.data;
            this.$router.push({
              name: "order",
              query: { cart_ids: JSON.stringify(cartIds) }
            });
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      });
      }

      
      // if(val.product.default_spes_desc) {
      //   this.show = true
      // } else {
      //   let data = {
      //     product_id: id,
      //     nums: 1
      //   };
        
      // }
    },
    // 获取购物车数量
    getCartNums() {
      this.$api.getCartNum().then(res => {
        if (res.status) {
          this.getCartNumsAction(res.data);
        }
      });
    },
    sortSpecs(dataObj, newSpecStr) {
      if (newSpecStr) {
        try {
          let newSpecArr = JSON.parse(newSpecStr);
          newSpecArr.sort((a, b) => (parseInt(a.sort) || 0) - (parseInt(b.sort) || 0));
          let sortedObj = {};
          newSpecArr.forEach(item => {
            if (dataObj.hasOwnProperty(item.name)) {
              sortedObj[item.name] = dataObj[item.name];
            }
          });
          for (let k in dataObj) {
            if (!sortedObj.hasOwnProperty(k)) {
              sortedObj[k] = dataObj[k];
            }
          }
          return sortedObj;
        } catch (e) {
          console.error("解析 newSpec 失败", e);
        }
      }
      return dataObj;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";

.drawer-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.5);
  visibility: hidden;
  -webkit-transition: opacity .3s 0s, visibility 0s .3s;
  transition: opacity .3s 0s, visibility 0s .3s;
  &.show {
    opacity: 1;
    visibility: visible;
    transition: opacity .3s 0s, visibility 0s 0s;
    .drawer-content{
      transform: translateY(0);
    }
  }
  .submit {
    width: 100%;
    background-color: #ff5722;
    border-color: #ff5722;
    border-width: 1px;
    font-size: 18px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    color: #fff;
    cursor: pointer;
  }
}

.drawer-content {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgb(255,255,255);
  box-shadow: 0 0 20px rgba(0,0,0,.2);
  transform: translateY(110%);
  transition-property: transform;
  transition-duration: 0.3s;
  .att-popup-header {
    display: inline-block;
    position: relative;
    padding: 0.3rem 0.3rem 0.3rem 5rem;
    width: 100%;
    border-top: 1px solid rgb(229,229,229);
    border-bottom: 1px solid rgb(229,229,229);
    margin-bottom: 10px;
    float: left;
    .thumb {
      position: absolute;
      width: 40px;
      height: 40px;
      top: -12px;
      left: 10px;
      margin-right: 10px;
      background-color: rgb(255,255,255);
      border: 1px solid rgb(221,221,221);
      border-radius: 3px;
    }
    .info {
      color:  #585858;
      div {
        margin-bottom: 10px;
      }
    }
  }
}
.add-wrap {
  position: absolute;
  bottom: 14px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  .info-img {
    background-position: -92px -71px;
    width: 46px !important;
    height: 46px !important;
    // position: absolute;
    background-image: url('~@/assets/images/video/video-pic.png');
    background-repeat: no-repeat;
    display: inline-block;
  }
  .add-cart {
    background: #de4d1e;
    width: 82px;
    height: 25px;
    border-radius: 3px;
    text-align: center;
    line-height: 25px;
    color: #ffffff;
    font-size: 14px ;
    margin-top: 10px;
    // position: absolute;
  }
  .nostock {
    background: #B0B0B0;
  }
}
.pro-flex-list {
  display: flex;
  flex-flow: row wrap;
  background: #fff;
  // justify-content: space-between;
  .pro {
    padding: 11px;
    width: 355px;
    height: 490px;
    margin: 15px;
    background: #fff;
    border: 1px solid #e5e5e5;
    transition: all 0.2s linear 0s;
    box-shadow: 2px 2px 4px #e3e3e3;
    position: relative;
    &:nth-child(3n - 2) {
      // margin-left: 0;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      box-shadow: 0 15px 20px rgba(0,0,0,0.1);
    }
    &.row-4 {
      width: 24%;
    }
    &.not {
      &.not {
        background: $theme-bg;
      }
    }
    &.active:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .pro-handle-icon {
        display: block;
      }
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
      .pro-img {
        width: 355px;
        height: 355px;
        margin: 0 auto 10px;
        position: relative;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .img-no {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: rgba(255,255,255,.7);
          display: flex;
          align-items: center;
          justify-content: center;
          >img {
            width: 195px;
            height: 195px;
          }
        }
      }
      .title {
        font-size: 14px;
        height: 42px;
        // line-height: 42px;
        font-weight: 500;
        color:#666;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        margin-top: 10px;
        margin-bottom: 5px;
      }
      .desc {
        height: 18px;
        font-size: 12px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #b0b0b0;
      }
      .price-wrap {
        padding: 10px 0;
        .price {
          color: #de4d1e;
          font-size: 28px;
          font-weight: normal;
        }
      }
      
    }
  }
}
//产品收藏添加购物车
.pro-handle-icon {
  display: none;
  position: absolute;
  height: 24px;
  top: 14px;
  cursor: pointer;
  padding: 3px 4px;
  span {
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.2s linear;
    color: $theme-color;
  }
  &:hover {
    span {
      opacity: 1;
      font-weight: 550;
    }
    // .icon {
    //   color: $theme-color;
    // }
  }
  .icon {
    font-size: 18px;
    vertical-align: -1px;
    margin-right: 3px;
    color: $theme-color;
    // color:#FFF;
  }
  &.pro-collet-icon {
    left: 10px;
  }
  &.pro-addcart-icon {
    right: 10px;
  }
}


.tr-group {
          margin-bottom: 15px;
          position: relative;
          display: flex;
          width: 100%;       
          padding-left: 20px;
          border-bottom: 1px solid #e5e5e5;
          padding-bottom: 4px;
          &.underline {
            padding-bottom: 10px;
            border-bottom: 1px solid $border;
          }
          .tr-title-left {
            color: #838383;
            font-size: 12px;
            display: inline-block;
            min-width: 60px;
            padding-right: 10px;
            height: 32px;
            line-height: 32px;
          }
          .tr-right {
            display: inline-block;
            flex: 1;
            .discounts-login {
              font-size: 12px;
              cursor: pointer;
              span {
                color: #e7442f;
              }
            }
            .now-price {
              color: $theme-color;
              text-align: left;
              margin-right: 20px;
              i {
                font-size: 16px;
              }
              .price-num {
                font-size: 22px;
              }
            }
            .old-price {
              color: #666;
              font-size: 12px;
            }
            .cx-item {
              padding: 2px 4px;
              background: $theme-color;
              color: #fff;
              margin-right: 10px;
              font-size: 12px;
              height: 24px;
              line-height: 24px;
            }
            .color,
            .size {
              font-size: 12px;
              border: 1px solid #b8b7bd;
              margin-right: 8px;
              display: inline-block;
              height: 28px;
              line-height: 28px;
              margin-bottom: 12px;
              &.active {
                border-color: $theme-color;
                background: $theme-color;
                color: #fff;
              }
              a {
                display: block;
                padding: 0 10px;
              }
              &:hover {
                border: 1px solid $theme-color;
              }
            }
            .weight {
              font-size: 12px;
            }
            .kc {
              color: #878787;
              display: inline-block;
              font-size: 12px;
              margin-left: 20px;
            }
          }
        }

.color.diable {
  color: #ccc;
  border: 1px solid #ccc;
  cursor: not-allowed !important;
  a{
    cursor: not-allowed !important;
  }
  &:hover {
    border: 1px solid #ccc !important;
  }
}


.integral{
	span {
		color:#FF4444;
		border: 1px solid #FF4444;
		font-size: 14px;
		border-radius: 4px;
		padding: 0px 10px;
		margin-top: 4px;
	}
}
</style>